import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { TradePartnerPage } from "src/routes/trade-partners/TradePartnerPage";
import { TradePartnersPage } from "src/routes/trade-partners/TradePartnersPage";
import { PaymentTermsPage } from "src/routes/trade-partners/payment-terms/PaymentTermsPage";
import { TradeCategoryLeadTimesPage } from "src/routes/trade-partners/trade-category-lead-times/TradeCategoryLeadTimesPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import {
  paymentTermsRoute,
  tradeCategoryLeadTimesRoute,
  tradePartnerRoute,
  tradePartnersRoute,
} from "src/routing/domains/tradePartnersPaths";

/**
 * `/trade-partners/*` route tree.
 *
 * Role: data router domain route.
 *
 * Legacy stack (pages still use `PageHeader`, not Beam page layouts):
 * `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page.
 * Lead times skips `ScrollableParentLayout` (page owns its own `ScrollableParent`).
 * When pages move to `PageHeaderLayout` / `GridTableLayout`, switch to
 * `AppShell` → `BeamNavbarLayout` → page (see `domains/projects.ts`).
 *
 * Path constants live in `tradePartnersPaths.ts` (imported by `RouteUrls.ts` / pages) to avoid a cycle
 * through this file's page `Component` imports.
 * Legacy `Routes.tsx` must not register these paths.
 */
const tradePartnersDomainRoute: RouteObject = {
  path: tradePartnersRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        // Static paths before `:idOrAdd` for clarity (RR6 already ranks static above params).
        { path: tradeCategoryLeadTimesRoute.path, Component: TradeCategoryLeadTimesPage },
        {
          Component: ScrollableParentLayout,
          children: [
            { index: true, Component: TradePartnersPage },
            { path: paymentTermsRoute.path, Component: PaymentTermsPage },
            { path: `${tradePartnerRoute.path}/*`, Component: TradePartnerPage },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};

/**
 * Migrated `/trade-partners/*` route trees registered in `Router.tsx`.
 */
export const tradePartnersRoutes = [tradePartnersDomainRoute];
